import React from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares"; 

const PaymentShimmer = () => {
  return (
    <section className="space-y-6">
      <DecorativeSquares />

      {/* Header */}
      <div className="flex items-center h-14 mt-5 bg-white px-8 shadow-sm">
        <div className="flex items-center p-2 rounded-full bg-gray-200 h-8 w-8" />
        <div className="mx-auto h-6 w-40 bg-gray-200 rounded-md" />
      </div>

      <div className="px-4 mt-8 space-y-4">
        <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-4 shadow-sm space-y-6">
          {/* Top User Row */}
          <div className="flex items-center gap-4">
            {/* Avatar */}
            <div className="h-12 w-12 rounded-full bg-gray-200" />

            {/* Name + Phone */}
            <div className="flex flex-col gap-2">
              <div className="h-4 w-32 bg-gray-200 rounded" />
              <div className="h-3 w-40 bg-gray-200 rounded" />
            </div>
          </div>

          {/* Amount Due */}
          <div className="flex flex-col items-center gap-2 mt-4">
            <div className="h-6 w-24 bg-gray-200 rounded" />
            <div className="h-4 w-28 bg-gray-200 rounded" />
          </div>

          <div className="border-t border-gray-100" />

          {/* Stats */}
          <div className="grid grid-cols-3 divide-x divide-gray-100">
            {[1, 2, 3].map((_, i) => (
              <div key={i} className="py-4 flex flex-col items-center gap-2">
                <div className="h-4 w-16 bg-gray-200 rounded" />
                <div className="h-3 w-24 bg-gray-200 rounded" />
              </div>
            ))}
          </div>

          <div className="border-t border-gray-100" />

          {/* Paysheet shimmer */}
          <div className="space-y-3">
            {[1, 2, 3, 4].map((_, i) => (
              <div key={i} className="h-10 w-full bg-gray-200 rounded-md" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentShimmer;
